import client from './client';

export interface ActivityLogEntry {
  activityId: number;
  username:   string;
  role:       string | null;
  actionType: string;
  description: string | null;
  entityType: string | null;
  entityId:   number | null;
  createdAt:  string;
}

export interface ActivityLogPage {
  items:      ActivityLogEntry[];
  total:      number;
  page:       number;
  pageSize:   number;
  totalPages: number;
}

export interface ActivityLogFilters {
  username?:   string;
  actionType?: string;
  dateFrom?:   string; // YYYY-MM-DD
  dateTo?:     string; // YYYY-MM-DD
  page?:       number;
  pageSize?:   number;
}

/** Every username that appears in the log, A–Z. */
export const getActivityLogUsernames = async (): Promise<string[]> => {
  const { data } = await client.get<{ data: string[] }>('/activity-log', { params: { usernames: 1 } });
  return data.data;
};

export const getActivityLog = async (filters: ActivityLogFilters = {}): Promise<ActivityLogPage> => {
  const params: Record<string, string | number> = {};
  if (filters.username)   params.username   = filters.username;
  if (filters.actionType) params.actionType = filters.actionType;
  if (filters.dateFrom)   params.dateFrom   = filters.dateFrom;
  if (filters.dateTo)     params.dateTo     = filters.dateTo;
  params.page     = filters.page     ?? 1;
  params.pageSize = filters.pageSize ?? 50;

  const { data } = await client.get<{ data: ActivityLogPage }>('/activity-log', { params });
  return data.data;
};

/**
 * Frontend-originated event types — for actions with no natural backend
 * mutation to hook into (search, filter, export, print, view).
 * Fire-and-forget: failures are swallowed so logging never blocks the UI.
 */
export type FrontendActionType = 'SEARCH' | 'FILTER' | 'EXPORT' | 'PRINT' | 'VIEW';

export const logFrontendActivity = (
  actionType: FrontendActionType,
  description?: string,
  entityType?: string,
  entityId?: number,
): void => {
  client
    .post('/activity-log', { actionType, description, entityType, entityId })
    .catch(() => { /* best-effort — never block the UI on logging failure */ });
};
